import { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import AlertService from '../../../../components/SweetAlert';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import { GET, newFetch, POST, PUT } from '../../../../helpers/fetch';

const Claims = ({ siteID, clientID, title = 'Claims' }) => {
  const [claimTypes, setClaimTypes] = useState([]);
  const [oldClaimTypes, setOldClaimTypes] = useState([]);
  const [newClaimTypes, setNewClaimTypes] = useState([]);
  const [hideInactive, setHideInactive] = useState(false);

  const fetchClaimTypes = async () => {
    let api_path = `/claimtypes/${siteID}?client_id=${clientID}`;
    let response = await newFetch(GET, api_path);
    if (response.success) {
      let claimTypesData = response.data;

      setClaimTypes(claimTypesData);
      setOldClaimTypes(JSON.parse(JSON.stringify(claimTypesData)));
    }
  };

  const handleUpdateOldClaimType = (i, e) => {
    let clone = [...oldClaimTypes];
    clone[i] = { ...clone[i], name: e.target.value };
    setOldClaimTypes(clone);
  };

  const handleUpdateOldActive = (i, e) => {
    let clone = [...oldClaimTypes];
    clone[i].active = !clone[i].active;
    setOldClaimTypes(clone);
  };

  const handleAddNewClaim = () => {
    setNewClaimTypes([
      ...newClaimTypes,
      {
        name: '',
        active: true,
      },
    ]);
  };

  const handleUpdateNewClaim = (i, e) => {
    let clone = [...newClaimTypes];
    clone[i] = { ...clone[i], name: e.target.value };
    setNewClaimTypes(clone);
  };

  const handleUpdateNewActive = (i, e) => {
    let clone = [...newClaimTypes];
    clone[i].active = !clone[i].active;
    setNewClaimTypes(clone);
  };

  const handleDeleteNewClaim = (i) =>
    setNewClaimTypes(
      [...newClaimTypes].filter((claimType, index) => index !== i)
    );

  const discardHandler = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard the unsaved changes?'
      )
    ) {
      setOldClaimTypes(claimTypes);
      setNewClaimTypes([]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to update the claim type?'
      )
    ) {
      let api_path = `/claimTypes`;
      // update old actions
      if (oldClaimTypes.length > 0) {
        let update_data = {
          claimTypes: oldClaimTypes.map((claimType) => ({
            id: claimType.id,
            client_id: claimType.client_id,
            name: claimType.name,
            active: claimType.active ? 1 : 0,
          })),
        };
        let update_response = await newFetch(PUT, api_path, update_data);

        ToastUtil.success(update_response.message);

        if (!update_response.success) return;
      }

      // create new actions
      if (newClaimTypes.length > 0) {
        let create_data = {
          claimTypes: newClaimTypes.map((claimType) => ({
            client_id: clientID,
            name: claimType.name,
            active: claimType.active ? 1 : 0,
          })),
        };
        let create_response = await newFetch(POST, api_path, create_data);

        ToastUtil.success(create_response.message);
        if (!create_response.success) return;
      }

      setNewClaimTypes([]);
      await fetchClaimTypes();
    }
  };

  useEffect(() => {
    fetchClaimTypes();
  }, [siteID, clientID]);

  return (
    <form onSubmit={(e) => handleSubmit(e)} className="d-flex flex-column">
      <div className="p-4 d-flex flex-column">
        <div className="d-flex justify-content-between mb-4 pb-2">
          <h5>{title}</h5>
          <div className="form-check">
            <input
              type="checkbox"
              name="hideInactiveCheck"
              id="hideInactiveCheck"
              className="me-2 form-check-input"
              value={hideInactive}
              onChange={() => setHideInactive(!hideInactive)}
            />
            <label className="form-check-label" htmlFor="hideInactiveCheck">
              Hide Inactive?
            </label>
          </div>
        </div>

        <div className="row border-bottom mb-2 pb-2">
          <div className="col-6 fw-bold">Name</div>
          <div className="col-2 fw-bold text-center">Active?</div>
          <div className="col-2 fw-bold text-center">Delete</div>
        </div>
        {oldClaimTypes.map(
          (claimType, index) =>
            (!hideInactive || claimType.active) && (
              <div key={index} className="row py-2">
                <div className="col-6">
                  <input
                    type="text"
                    className="form-control adjust-fs"
                    value={claimType.name}
                    onChange={(e) => handleUpdateOldClaimType(index, e)}
                  />
                </div>

                <div
                  className="col-2 text-center"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => handleUpdateOldActive(index, e)}
                >
                  {claimType.active ? (
                    <i className="fas fa-check text-success pt-2"></i>
                  ) : (
                    <i className="fas fa-times text-danger pt-2"></i>
                  )}
                </div>
                <div className="col-2"></div>
              </div>
            )
        )}

        {newClaimTypes.map((claimType, index) => (
          <div key={index} className="row py-2">
            <div className="col-6">
              <input
                type="text"
                className="form-control adjust-fs"
                value={claimType.name}
                onChange={(e) => handleUpdateNewClaim(index, e)}
              />
            </div>

            <div
              className="col-2 text-center"
              style={{ cursor: 'pointer' }}
              onClick={(e) => handleUpdateNewActive(index, e)}
            >
              {claimType.active ? (
                <i className="fas fa-check text-success pt-2"></i>
              ) : (
                <i className="fas fa-times text-danger pt-2"></i>
              )}
            </div>

            <div
              className="col-2 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => handleDeleteNewClaim(index)}
            >
              <i className="fas fa-trash pt-2"></i>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-block btn-outline-brand text-start mt-2 p-3 adjust-fs adjust-shadow"
          onClick={() => handleAddNewClaim()}
        >
          <i className="fas fa-plus me-2" /> Add New Claim Type
        </button>
        <div
          style={{
            height: '4.5rem',
          }}
          className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
        >
          <button
            type="button"
            onClick={discardHandler}
            className="btn btn-outline-brand adjust-fs adjust-shadow"
            style={{ width: '12rem' }}
          >
            Discard changes
          </button>
          <button
            type="submit"
            className="btn btn-brand ms-3 adjust-fs adjust-shadow"
            style={{ width: '12rem' }}
          >
            Save changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default withRouter(Claims);
